import { ENDPOINT_GET_LOAN_OFFER } from '@shared/sec-loans'
import { GetDataStep } from '@ui-common/steps/GetDataStep'
import { callEndpoint } from '@ui-common/utils/http'
import { useIntl } from 'react-intl'
import { ActorRefFrom } from 'xstate'

import { WizardMachineType } from '../../wizard/wizardMachine'
import { useLoanOfferFormContext } from '../formContext'

export const GetLoanOfferStep = ({ parentService }: { parentService: ActorRefFrom<WizardMachineType> }) => {
  const { loanOfferId, exitWithConfirmDialog } = useLoanOfferFormContext()
  const { formatMessage } = useIntl()

  return (
    <GetDataStep
      parentService={parentService}
      getDataCallback={() => callEndpoint(ENDPOINT_GET_LOAN_OFFER, { pathParams: { loanOfferId } })}
      onAbort={exitWithConfirmDialog}
      heading={formatMessage({ id: 'common-loading-application-data' })}
    />
  )
}
